<h2 mat-dialog-title *ngIf="temProblemas">Verificação de integridade concluída</h2>

<mat-dialog-content>
  <!-- Estado de sucesso total -->
  <div *ngIf="!temProblemas" class="success-state">
    <mat-icon class="success-icon">check_circle</mat-icon>
    <h2>Verificação concluída</h2>
    <p>{{ data.totalVerificado }} documentos verificados — todos íntegros.</p>
    <p class="hint">Nenhuma ação necessária.</p>
  </div>

  <!-- Estado com reenviados/falhas -->
  <div *ngIf="temProblemas">
    <div class="counters">
      <span class="counter success"><mat-icon>check_circle</mat-icon> {{ data.integros }} íntegros</span>
      <span class="counter warning" *ngIf="data.reenviados > 0"><mat-icon>sync</mat-icon> {{ data.reenviados }} reenviados</span>
      <span class="counter danger" *ngIf="data.falhas > 0"><mat-icon>error</mat-icon> {{ data.falhas }} falhas</span>
      <span class="counter pending" *ngIf="data.pendentes > 0"><mat-icon>schedule_send</mat-icon> {{ data.pendentes }} pendentes</span>
    </div>

    <div *ngIf="reenviados.length > 0" class="section">
      <h3>Documentos reenviados</h3>
      <table>
        <thead>
          <tr><th>Documento</th><th>Anterior</th><th>Novo</th></tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of reenviados">
            <td>{{ item.nome }}</td>
            <td class="mono">{{ item.numeroAnterior }}</td>
            <td class="mono">{{ item.numeroNovo }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div *ngIf="falhas.length > 0" class="section">
      <h3>Falhas</h3>
      <table>
        <thead>
          <tr><th>Documento</th><th>Erro</th></tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of falhas">
            <td>{{ item.nome }}</td>
            <td class="text-danger">{{ item.erro }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <div *ngIf="pendentesEnvio.length > 0" class="section">
      <h3>Pendentes de envio</h3>
      <p class="hint">Esses documentos ainda não foram enviados ao SIGAD. Use os botões na área "Atualizar processo digital SIGAD" para enviá-los.</p>
      <table>
        <thead>
          <tr><th>Documento</th></tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of pendentesEnvio">
            <td>{{ item.nome }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-raised-button color="primary" (click)="fechar()">Fechar</button>
</mat-dialog-actions>
